import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {useTheme} from 'styled-components'

export const ProjectTransformHelpText = () => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    return (
        <DetailsField>
            <Text palette="neutral" shade="500" size="textSm">
                {t('commons:project_type')}
            </Text>
            <Text weight="500" size="textSm">
                {t('commons:continuous')}
            </Text>
            <Flexbox align="center" gap={1}>
                <AlertCircleIcon size={14} color={palette.orange[500]} />
                <Text palette="orange" shade="800" size="textSm">
                    {t('projects:transform_project_hint_warning')}
                </Text>
            </Flexbox>
        </DetailsField>
    )
}
